import type { CoaAccountType } from '../components/CoaPreview';

export function isDebitNatural(type: CoaAccountType): boolean {
  return type === 'asset' || type === 'cost' || type === 'expense' || type === 'other_expense';
}

/**
 * Legacy normal-side advisory retained only for possible external callers.
 * COA import no longer uses this: the uploaded sign determines the side.
 */
export function normalSideMismatch(type: CoaAccountType, balance: number): boolean {
  if (!balance) return false;
  return isDebitNatural(type) ? balance < 0 : balance > 0;
}

export interface TrialBalanceTotals {
  debit: number;
  credit: number;
  /** Exact comparison value, avoids binary-float warnings such as 4.66e-10. */
  differenceCents: number;
  /** Signed debit − credit, shown as the footer Net total. */
  net: number;
}

function balanceToCents(balance: number): number {
  if (!Number.isFinite(balance)) return 0;
  return Math.sign(balance) * Math.round(Math.abs(balance) * 100);
}

export function trialBalanceTotals(
  rows: Array<{ balance: number; account_type?: CoaAccountType }>,
): TrialBalanceTotals {
  let debitCents = 0;
  let creditCents = 0;
  for (const r of rows) {
    // Import convention: the uploaded figure itself chooses the side.
    // Positive = debit; negative = credit; net is the signed column sum.
    const cents = balanceToCents(r.balance);
    if (cents >= 0) debitCents += cents;
    else creditCents -= cents;
  }
  return {
    debit: debitCents / 100,
    credit: creditCents / 100,
    differenceCents: debitCents - creditCents,
    net: (debitCents - creditCents) / 100,
  };
}
